export const CREATE_NEW_USER = "USER@CREATE_NEW_USER";
export const CREATE_NEW_USER_INIT = "USER@CREATE_NEW_USER_INIT";
export const CREATE_NEW_USER_SUCCESS = "USER@CREATE_NEW_USER_SUCCESS";
export const CREATE_NEW_USER_FAILED = "USER@CREATE_NEW_USER_FAILED";

export const GET_ALL_USERS = "USER@GET_ALL_USERS";
export const GET_ALL_USERS_INIT = "USER@GET_ALL_USERS_INIT";
export const GET_ALL_USERS_SUCCESS = "USER@GET_ALL_USERS_SUCCESS";
export const GET_ALL_USERS_FAILED = "USER@GET_ALL_USERS_FAILED";

export const GET_USER_DETAIL = "USER@GET_USER_DETAIL";
export const GET_USER_DETAIL_INIT = "USER@GET_USER_DETAIL_INIT";
export const GET_USER_DETAIL_SUCCESS = "USER@GET_USER_DETAIL_SUCCESS";
export const GET_USER_DETAIL_FAILED = "USER@GET_USER_DETAIL_FAILED";

export const UPDATE_USER_DETAIL = "USER@UPDATE_USER_DETAIL";
export const UPDATE_USER_DETAIL_INIT = "USER@UPDATE_USER_DETAIL_INIT";
export const UPDATE_USER_DETAIL_SUCCESS = "USER@UPDATE_USER_DETAIL_SUCCESS";
export const UPDATE_USER_DETAIL_FAILED = "USER@UPDATE_USER_DETAIL_FAILED";

export const UPDATE_USER_STATUS = "USER@UPDATE_USER_STATUS";
export const UPDATE_USER_STATUS_INIT = "USER@UPDATE_USER_STATUS_INIT";
export const UPDATE_USER_STATUS_SUCCESS = "USER@UPDATE_USER_STATUS_SUCCESS";
export const UPDATE_USER_STATUS_FAILED = "USER@UPDATE_USER_STATUS_FAILED";

export const GET_USER_ROLES = "USER@GET_USER_ROLES";
export const GET_USER_ROLES_INIT = "USER@GET_USER_ROLES_INIT";
export const GET_USER_ROLES_SUCCESS = "USER@GET_USER_ROLES_SUCCESS";
export const GET_USER_ROLES_FAILED = "USER@GET_USER_ROLES_FAILED";
